<template>
  <v-container>
    <v-row>
      <v-col>
        <layer-table />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {
    LayerTable: () => import('@/components/layers/LayerTable')
  }
};
</script>
